import { defineTable } from "convex/server";
import { v } from "convex/values";
import { modulesTypes } from "../../system/permissions";

export const billingPeriod = v.union(v.literal("monthly"), v.literal("yearly"));

export const validatorSubscriptionPlan = v.object({
  // Información básica
  name: v.string(),
  description: v.string(),

  // Integración con Dodo Payments
  dodoProductId: v.string(),
  price: v.number(),
  billingPeriod,

  // Trial sin tarjeta
  trialDays: v.number(),

  // Límites SOFT (para notificaciones)
  limits: v.object({
    maxUsers: v.number(), // 10 usuarios
    maxBranches: v.number(), // 3 sucursales
    storageGB: v.number(), // 10 GB
    invoicesPerMonth: v.number(), // 1000 facturas/mes
    // AI Assistant limits (0 = deshabilitado, -1 = ilimitado)
    aiMessagesPerMonth: v.optional(v.number()),
    aiTokensPerMonth: v.optional(v.number()),
  }),

  // Módulos incluidos
  includedModules: v.array(modulesTypes),

  // Características para mostrar en frontend
  features: v.array(v.string()),

  // Control
  isActive: v.boolean(),
  isDefault: v.boolean(),
});

export const subscription_plans = defineTable(validatorSubscriptionPlan)
  .index("by_is_active", ["isActive"])
  .index("by_is_default", ["isDefault"]);
